import { SettlementInfoWrapper, useSettlementContext } from '@inflearn/modals';
import { useEvent } from 'react-use';

import type { EventPropsMap } from '../../constants/MODAL_EVENT_ID';
import { EVENT_ID } from '../../constants/MODAL_EVENT_ID';

export default function _SettlementModalWrapper() {
  return (
    <SettlementInfoWrapper>
      <SettlementModalContainer />
    </SettlementInfoWrapper>
  );
}

const SettlementModalContainer = () => {
  const { Modal, updateCompleteCallback } = useSettlementContext();

  useEvent(
    EVENT_ID.SETTLEMENT_MODAL,
    (e: CustomEventInit<EventPropsMap[typeof EVENT_ID.SETTLEMENT_MODAL]>) => {
      Modal.open();

      if (e.detail?.onComplete) {
        updateCompleteCallback(e.detail.onComplete);
      }
    },
    window
  );

  return null;
};
